var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};
export var createHiddenNode = function createHiddenNode(ref, element) {
  var _node$parentNode;
  if (element) {
    return element;
  }
  var node = ref.current;
  var hiddenTextarea = document.createElement('textarea');
  hiddenTextarea.setAttribute('tabindex', '-1');
  hiddenTextarea.setAttribute('aria-hidden', 'true');
  node === null || node === void 0 || (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 || _node$parentNode.appendChild(hiddenTextarea);
  // Используем для калькуляции размеров отображаемого поля
  forceHiddenStyles(hiddenTextarea);
  return hiddenTextarea;
};
export var calculateNodeHeight = function calculateNodeHeight(hiddenTextarea, sizingData, value) {
  var minRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var maxRows = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
  var paddingSize = sizingData.paddingSize,
    sizingStyle = sizingData.sizingStyle;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = hiddenTextarea.scrollHeight;
  hiddenTextarea.value = 'x';

  // eslint-disable-next-line max-len
  var rowHeight = sizingData.sizingStyle.lineHeight ? parseFloat(sizingData.sizingStyle.lineHeight) : hiddenTextarea.scrollHeight - paddingSize.vertical;
  var minHeight = rowHeight * minRows + (sizingStyle.boxSizing === 'border-box' ? paddingSize.vertical : 0);
  var maxHeight = rowHeight * maxRows + (sizingStyle.boxSizing === 'border-box' ? paddingSize.vertical : 0);
  return {
    height: Math.min(maxHeight, Math.max(minHeight, height)),
    isOverflow: height > maxHeight
  };
};